<template>
  <div class="row">
    <div class="col-12">
      <b-card header="<i class='fa fa-file-o'></i> Detil Pengajuan tes">
        <div v-if="!DataHeader || !listdokap" style="height: 20rem"
          class="d-flex align-items-center justify-content-center">
          <half-circle-spinner :animation-duration="1000" :size="60" :color="'#000000'" />
        </div>
        <div v-if="DataHeader && listdokap" class="">
          <div class="row">
            <div class="col-12">
              <b-card header="<i class='fa fa-file-o'></i> Data Pengajuan Izin">
                <div class="row">
                  <div class="col-6">
                    <div class="row">
                      <div class="col-12">
                        <table class="table table-bordered table-sm">
                          <tr>
                            <td class="d-none d-sm-block">{{ DataHeader.URAIAN }}</td>
                            <td>{{ DataHeader.npwp }}</td>
                          </tr>
                          <tr>
                            <td class="d-none d-sm-block">Nama</td>
                            <td>{{ DataHeader.NM_PERUSAHAAN }}</td>
                          </tr>
                          <tr>
                            <td class="d-none d-sm-block">Alamat</td>
                            <td>{{ DataHeader.AL_PERUSAHAAN }}</td>
                          </tr>
                          <tr>
                            <td class="d-none d-sm-block">No HP/Telepon</td>
                            <td>{{ DataHeader.no_hp }}</td>
                          </tr>
                          <tr>
                            <td class="d-none d-sm-block">Email</td>
                            <td>{{ DataHeader.email }}</td>
                          </tr>
                        </table>
                      </div>
                      <div class="col-12">
                        <table class="table table-bordered table-sm">
                          <tr>
                            <td class="d-none d-sm-block">Jenis Permohonan Izin</td>
                            <td>{{ DataHeader.nama_ijin }}</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="row">
                      <div class="col-12">
                        <table class="table table-bordered table-sm">
                          <tr>
                            <td>Status</td>
                            <td>{{ DataHeader.ur_status }}</td>
                          </tr>
                          <tr>
                            <td>No Setuju</td>
                            <td>{{ DataHeader.no_setuju }}</td>
                          </tr>
                          <tr>
                            <td>Tgl Setuju</td>
                            <td>{{ DataHeader.tgl_setuju }}</td>
                          </tr>
                        </table>
                      </div>
                      <div class="col-12">
                        <table class="table table-bordered table-sm">
                          <tr>
                            <td class="d-none d-sm-block">Kantor</td>
                            <td>020400 - KPU BC Tipe B Batam</td>
                          </tr>
                          <tr>
                            <td class="d-none d-sm-block">No Permohonan</td>
                            <td>{{ DataHeader.no_mohon }}</td>
                          </tr>
                          <tr>
                            <td class="d-none d-sm-block">Tanggal Permohonan</td>
                            <td>{{ DataHeader.tgl_mohon }}</td>
                          </tr>

                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>
            <div class="col-12">
              <b-card header="<i class='fa fa-file-o'></i> Dokumen Pelengkap">
                <div class="row">
                  <div class="col-12">
                    Lampiran Dokumen
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>Nama Dokumen</th>
                          <th>Nomor</th>
                          <th>Tanggal</th>
                          <th class="d-none d-sm-block">Keterangan</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="dokap in listdokap" :key="dokap.id_permohonan_dokap">
                          <td>{{ dokap.nama_dokap }}</td>
                          <td>{{ dokap.isian1 }}</td>
                          <td>{{ dokap.isian2 }}</td>
                          <td class="d-none d-sm-block">{{ dokap.keterangan }}</td>
                          <td>
                            <!--a :href="'http://192.168.16.5/backper/public/' + dokap.url_file + '/' + dokap.nm_file" target="_blank" class="btn btn-warning"><i class="fa fa-download"></i></a-->
                            <!-- <a v-if="dokap.url_file !== null" :href="'http://perijinanbcbatam.beacukai.go.id/repository/perijinanbatam/' + dokap.url_file + '/' + dokap.nm_file" target="_blank" class="btn btn-warning"><i class="fa fa-download"></i></a> -->
                            <button title="Edit Dokumen/Data Pelengkap" v-if="dokap.kd_dokap === 151" type="button"
                              @click="opendtl(dokap.id_permohonan_dokap)" class="btn btn-success"><i
                                class="fa fa-eye"></i></button>
                            <!-- <a v-if="dokap.url_file !== null" :href="'http://103.233.145.212/backper/public' + dokap.url_file + '/' + dokap.nm_file" target="_blank" class="btn btn-warning"><i class="fa fa-download"></i></a> -->
                            <a v-if="dokap.url_file !== null" :href="dokap.url_file" target="_blank"
                              class="btn btn-warning"><i class="fa fa-download"></i></a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-card>
            </div>
            <div class="col-12">
              <b-card header="<i class='fa fa-file-o'></i> Dokumen Pelengkap">
                <div class="row">
                  <div class="col-12">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>Nama Dokumen</th>
                          <th class="d-none d-sm-block">Nomor</th>
                          <th>Tanggal</th>
                          <th class="d-none d-md-block">Keterangan</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="dokapptg in listdokapptg" :key="dokapptg.id_permohonan_dokap">
                          <td>{{ dokapptg.nama_dokap }}</td>
                          <td class="d-none d-sm-block">{{ dokapptg.isian1 }}</td>
                          <!-- <td>{{ dokap.isian1 + referensiDokapDtl(dokap.tabel_ref, dokap.kolom1, dokap.kolom2, dokap.isian1) }}</td> -->
                          <td>{{ dokapptg.isian2 }}</td>
                          <td class="d-none d-md-block">{{ dokapptg.keterangan }}</td>
                          <td>
                            <a title="Download Dokumen Pelengkap" v-if="dokapptg.nm_file !== null"
                              :href="$http.options.base + dokapptg.url_file + '/' + dokapptg.nm_file" target="_blank"
                              class="btn btn-warning"><i class="fa fa-download"></i></a>
                            <!-- <a title="Download Dokumen Pelengkap" v-if="dokapptg.nm_file !== null" :href="'http://localhost/backper/public' + dokapptg.url_file + '/' + dokapptg.nm_file" target="_blank" class="btn btn-warning"><i class="fa fa-download"></i></a> -->
                            <!-- <button title="Edit Dokumen/Data Pelengkap" type="button" @click="editDokap(dokapptg.id_permohonan_dokap)" class="btn btn-primary" v-if= "DataHeader.status === '50'"><i class="fa fa-edit"></i></button> -->
                            <button title="Hapus Dokumen/Data Pelengkap" v-if="dokapptg.fl_mandatory === null"
                              class="btn btn-danger" @click="confir(dokapptg.id_permohonan_dokap)"><i
                                class="fa fa-trash-o"></i></button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-card>
            </div>

            <div class="col-12">
              <router-link :to="'/browseftz'" class="btn btn-secondary pull-right"><i class="fa fa-mail-reply"></i> Back
              </router-link>
            </div>
          </div>
        </div>
      </b-card>

      <b-modal hide-footer title="Detail Dokumen Pelengkap" v-model="Modaleditdtl" @ok="Modaleditdtl = false" size="lg">
        <div class="form-group row">
          <div class="col-12">
            <!-- BUAT BIKIN SCROLL -->
            <div style="height:500px;max-height:300px;overflow-y:scroll;">
              <table class="table table-responsive-sm table-bordered">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Nomor Peti Kemas</th>
                    <th>Ukuran</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(peti, index) in cont" :key="peti.isian1">
                    <td>{{ index + 1 }}</td>
                    <td>{{ peti.isian1 }}</td>
                    <td>{{ peti.isian2 }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { HalfCircleSpinner } from 'epic-spinners'

export default {
  components: { HalfCircleSpinner },
  data () {
    return {
      Modaleditdtl: false,
      DataHeader: null,
      listdokap: null,
      listdokapptg: null,
      idijin: '',
      cont: [],
      dokap_current: ''
    }
  },
  created () {
    this.getHeader()
    this.getDokap()
    this.getDokapptg()
  },
  methods: {
    getHeader () {
      var data = {
        user: this.$store.getters['auth/user']['username'],
        idmohon: this.$route.params.idmohon
      }
      this.$http.post('dtlheader', data)
        .then(response => {
          this.DataHeader = response.data
          this.idijin = response.data.id_ijin
          this.getDokap(response.data.id_ijin)
        })
    },
    getDokap () {
      var idijinn = {
        user: this.$store.getters['auth/user']['username'],
        idijin: this.$route.params.idmohon
      }
      this.$http.post('dokap', idijinn)
        .then(response => {
          this.listdokap = response.data
        })
    },
    getDokapdtl () {
      var iddokap = {
        iddokap: this.dokap_current
      }
      this.$http.post('dokapdtl', iddokap)
        .then(response => {
          this.cont = response.data
        })
    },
    addModal () {
      this.ModalDokap = true
      this.Reset()
    },
    dlDokap (id) {
      var dokap = {
        idrekam: this.DataHeader.nip_rekam,
        iddokap: id
      }
      this.$http.post('dlDokap', dokap)
    },
    opendtl (id) {
      this.Modaleditdtl = true
      this.dokap_current = id
      this.getDokapdtl()
    },
    getDokapptg () {
      var idijinn = {
        idijin: this.$route.params.idmohon
      }
      this.$http.post('bc/petugas/approvedokapptg', idijinn)
        .then(response => {
          this.listdokapptg = response.data
        })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/Brows/DetilBrowsFtz.vue?16eaa435